import { Button, Flex, SimpleGrid } from "@chakra-ui/react";
import { shade } from "polished";
import { useCallback, useState } from "react";
import { FieldValues, SubmitHandler } from "react-hook-form";

import { HTMLText } from "../../../../components/atoms/Div/HTMLText";
import { MultipleChoiceRadioQuestionDefault } from "../../../../components/organisms/RadioQuestion/MultipleChoiceRadioQuestion/MultipleChoiceRadioQuestionDefault";
import { ReactSelectQuestion } from "../../../../components/organisms/SelectQuestion/ReactSelectQuestion";
import { Loader } from "../../../../components/templates/Loader";
import { useWinningRegistration } from "../../hooks/useWinningRegistration";

interface UnifyQrcode {
  question_unity: string;
  form_message: string;
  list_view: string;
}

interface WinningRegistration {
  id: string;
  slug: string;
  status: boolean;
  name: string;
  description: string;
  thanks_message: string;
  company_id: string;
  roulette_id: string;
  bonus_id: string;
  company: {
    name: string;
    slug: string;
  };
}

interface IProps {
  winningRegistrations: WinningRegistration[];
  unifyQrCode: UnifyQrcode;
  radical: string;
}

export function WinningRegistrationUnits({
  winningRegistrations,
  unifyQrCode,
  radical,
}: IProps) {
  const { company, whiteLabel } = useWinningRegistration();
  const [selectPage, setSelectPage] = useState("");
  const btnColor = company?.color || "#3182CE";

  const handleSubmitPage: SubmitHandler<FieldValues> = useCallback(async () => {
    const findWinningRegistration = winningRegistrations.find(
      (winningRegistration) => winningRegistration.id === selectPage
    );

    if (findWinningRegistration) {
      window.location.assign(
        `/premiado/${findWinningRegistration.company.slug}/${findWinningRegistration.slug}`
      );
    }
  }, [company.slug, winningRegistrations, selectPage]);

  return (
    <Loader
      isLoading={winningRegistrations && winningRegistrations.length !== 0}
      whiteLabel={whiteLabel}
    >
      <HTMLText html={unifyQrCode.form_message} />
      <Flex as="form" direction="column" onSubmit={handleSubmitPage}>
        <SimpleGrid spacingY={4} columns={1} mt="3">
          {unifyQrCode.list_view === "checkbox" ? (
            <MultipleChoiceRadioQuestionDefault
              label={unifyQrCode.question_unity}
              name="winning_registration_id"
              options={winningRegistrations
                .sort((a, b) => (a.company?.name > b.company?.name ? 1 : -1))
                .map((winningRegistration) => ({
                  name: winningRegistration.company?.name.replace(
                    radical ? radical : "*-",
                    ""
                  ),
                  value: winningRegistration.id,
                }))}
              setValue={(value: string) => {
                setSelectPage(value);
              }}
              isRequired
              selectColor={company?.color}
            />
          ) : (
            <ReactSelectQuestion
              label={unifyQrCode.question_unity}
              name="search_id"
              options={winningRegistrations
                .sort((a, b) => (a.company?.name > b.company?.name ? 1 : -1))
                .map((search) => ({
                  name: search.company?.name.replace(
                    radical ? radical : "*-",
                    ""
                  ),
                  value: search.id,
                }))}
              setValue={(value: string) => {
                setSelectPage(value);
              }}
              isRequired
            />
          )}
        </SimpleGrid>
        <Flex justify="flex-end">
          <Button
            type="submit"
            form="send-form"
            onClick={handleSubmitPage}
            fontWeight="normal"
            color="#fff"
            bg={company?.color}
            _hover={{
              bg: shade(0.3, btnColor),
            }}
            maxW="40"
            disabled={selectPage !== "" ? false : true}
          >
            Enviar
          </Button>
        </Flex>
      </Flex>
    </Loader>
  );
}
